export class WebMessageStatus {
  public static readonly Success = 'Success';
  public static readonly Warn = 'Warn';
  public static readonly Error = 'Error';
  public static readonly Info = 'Info';
}
